import React, { useState } from 'react'
import { Text, TooltipText, useTooltip } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'

const EarlyClaimFee: React.FC<{
  penaltyStart: number
  penaltyDelta: number
  penaltyPercent: number
}> = ({ penaltyStart, penaltyDelta, penaltyPercent }) => {
  const { t } = useTranslation()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text bold mb="4px">
        {t('Early claim fee: %fee%%', { fee: penaltyPercent / 100 })}
      </Text>
      <Text>
        {t(
          'Starts from %penaltyStart%%, decreases %penaltyDelta%% everyday. Timer resets every time you claim rewards from the lock.',
          {
            penaltyStart: penaltyStart / 100, penaltyDelta: penaltyDelta / 100
          },
        )}
      </Text>
    </>,
    { placement: 'bottom-start' },
  )

  return (
    <>
      {tooltipVisible && tooltip}
      <TooltipText ref={targetRef} small textTransform="lowercase">
        {penaltyPercent / 100}% early claim penalty fee
      </TooltipText>
    </>
  )
}

export default EarlyClaimFee
